import PatientReferralSelect from './PatientReferralSelect';
import PatientReferralSelectUI from './PatientReferralSelectUI';

export default PatientReferralSelect;

export { PatientReferralSelectUI };
